import script from "./PopupWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupWrapper.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__